import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { userHasTasksEnabledRedir } from '../core/auth';

const ProjectsRoute = () => {
  const { site } = useParams();
  return (
    <Switch>
      <Route path="/:site/projects/">
        <Redirect to={`/${site || ''}/tasks/work-orders`} />
      </Route>
    </Switch>
  );
};

export default userHasTasksEnabledRedir(ProjectsRoute);
